import http from "../http-common";

class FollowupLogNotificationService {
  createFollowupLog(data: any) {
    return http.post(`/crm/followuplogs`, data);
  }

  getFollowuplogs(page: any, pageSize: any) {
    return http.get(`/crm/followuplogs?page=${page}&pageSize=${pageSize}`);
  }

  getFollowuplogByEmail(email: any) {
    return http.get(`/crm/followuplogs/email?email=${email}`);
  }

  deleteFollowupLog(id: any) {
    return http.delete(`/crm/followuplogs/${id}`);
  }
}

export default new FollowupLogNotificationService();
